var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfChapterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.199,
    height: 15.7,
    viewBox: "0 0 13.199 15.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#8e8e8e;stroke-width:0.7px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.65 -7.65)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M44,8v2.5h2.5",
    transform: "translate(-22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.5,10.5,22,8H12V23H24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.635,20.022c-2.141.6,4.778,7.072,5.244,4.913s-8.228.9-6.691,2.4,3.587-7.9,1.447-7.313Z",
    transform: "translate(-6.192 -8.247)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfChapterIcon);
export default __webpack_public_path__ + "static/media/pdf-chapter-icon.5607776765124a1c603edf2f794f85f3.svg";
export { ForwardRef as ReactComponent };